import {keyToCoords} from "./keyToCoords";

export const getHexDistance = (hexKey1, hexKey2) => {
  const [q1, r1] = keyToCoords(hexKey1);
  const [q2, r2] = keyToCoords(hexKey2);
  const dr = r2 - r1;
  const dq = q2 - q1;
  return (Math.abs(dr) + Math.abs(dq) + Math.abs(dr + dq)) / 2;
}